module.exports = __webpack_public_path__ + "static/media/2_Report on Vlab ICMT.9262f5ea.pdf";